// extracted by mini-css-extract-plugin
module.exports = {"paragraphwrapper":"Paragraph_paragraphwrapper__BYRxz","citationHighlighted":"Paragraph_citationHighlighted__kbMO0"};